import Image from "next/image";

import { RichText } from "@/components/richText/richText.component";

import type { GetHomePageQueryResult } from "@/sanity.types";

import { SpotlightHeroAction } from "./spotlightHeroAction.component";

export const SpotlightHero = ({ block }: SpotlightHeroProps) => {
  const imageUrl = block.image?.url;
  if (!imageUrl) return null;

  const belowCtaDescription = block.belowCTAdescription;
  const hasBelowCtaDescription = Boolean(belowCtaDescription?.length);

  return (
    <section
      data-testid="spotlight-hero"
      className="bg-greyscale-headline relative isolate flex w-full overflow-hidden text-white lg:min-h-150">
      <picture>
        {block.mobileImage?.url ? (
          <source media="(max-width: 1023px)" srcSet={block.mobileImage.url} />
        ) : null}
        <Image
          data-testid="spotlight-hero-image"
          src={imageUrl}
          alt={block.image.alt?.trim() ?? ""}
          fill
          preload
          sizes="100vw"
          className="absolute inset-0 -z-20 object-cover"
        />
      </picture>
      <div className="container flex w-full flex-col gap-8 px-4 py-10 sm:py-12 lg:gap-18.75 lg:py-14">
        <div className="flex flex-col gap-2">
          <RichText asH1={block.asH1}>{block.title}</RichText>
          <div>
            <RichText>{block.description}</RichText>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <SpotlightHeroAction block={block} />
        </div>
        {hasBelowCtaDescription ? (
          <div
            data-testid="spotlight-hero-below-cta"
            className="[&_a]:underline [&_a]:underline-offset-4">
            <RichText>{belowCtaDescription}</RichText>
          </div>
        ) : null}
      </div>
    </section>
  );
};

type SpotlightHeroBlock = Extract<
  NonNullable<NonNullable<GetHomePageQueryResult>["pageBuilder"]>[number],
  { _type: "spotlightHero" }
>;

export type SpotlightHeroProps = { block: SpotlightHeroBlock };
